import React, {Dispatch, useState} from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import styles from './styles.module.scss'
import '../../../../styles/_V2/components/swiper.scss'
import ArrowLeftIcon from "../../../../assets/_V2/svg/ArrowLeftIcon";
import ArrowRightIcon from "../../../../assets/_V2/svg/ArrowRightIcon";
import Switcher from "../../Switcher";
import {Link} from "gatsby";


import { getData } from "./data"
import {useLocalizationContext} from "../../../../localization/useLocalizationContext";
import pro from "../../../../pages-data/discounts/pro";


interface PeriodItem {
  name: string
  code: string
  color: string
  description: string
  price: string
  priceFull?: string
  currency?: string
  discount?: string
  amountPrice?: string
  button?: string
}

interface TariffPeriod {
  label: string
  name: string
  items: PeriodItem[]
}


interface Props {
  className? : string
  setMobileSelectedTariff: Dispatch<any>
  setCurrentPeriod: Dispatch<any>
  currentPeriod: string
  modulesCost: {
    cashier: number
    smart: number
    pro: number
    enterprise?: number
  }
  scrolledBelowTariffs: boolean
}

export default function Tariffs(props : Props) {
  const localizationContext = useLocalizationContext()

  const switcherData = getData(localizationContext.locale).periods.map((period: TariffPeriod) => ({
    name: period.name,
    label: period.label,
    active: period.name === props.currentPeriod
  }));

  const currentPeriodData = getData(localizationContext.locale).periods.find((period) => period.name === props.currentPeriod);

  const onSlideChange = (swiper) => {
    props.setMobileSelectedTariff(currentPeriodData?.items[swiper.realIndex].code.toLowerCase());
  }

  const numberWithSpaces = (number) => {
    const numberString = number.toString();

    // Проверяем, если длина числа больше 4
    if (numberString.length > 4) {
      return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    // Если длина числа 4 или меньше, возвращаем число как есть
    return numberString;
  };

  const RenderItem = (item: PeriodItem, periodLabel: string) => {
    const periodName = currentPeriodData?.name;

    return (
      <div
        key={item.title}
        className={classNames(
            styles.tariffs__item,
            styles.tariffsItem,
            {[styles.tariffsItemCompact]: props.scrolledBelowTariffs}
        )}
      >
        { item.popular && (
            <span className={styles.tariffsItem__popular}>
              Популярный тариф
            </span>
        )}
        <h3 className={classNames(
            styles.tariffsItem__title,
            styles[item.color]
        )}>
          { item.name }
        </h3>
        {!props.scrolledBelowTariffs && (
            <p className={styles.tariffsItem__description}>
              {item.description}
            </p>
        )}
        {!props.scrolledBelowTariffs && (
        <div className={styles.tariffsItem__priceFull__wrapper}>
          {item.priceFull
              ? (
                  <>
                    <span className={styles.tariffsItem__priceFull}>{ numberWithSpaces(item.priceFull)}
                      {' '}{ item.currency ? item.currency : '₽' }
                    </span>
                    <span className={styles.tariffsItem__priceFull__discountBadge}>
                      {item.discount}
                    </span>
                  </>
              )
              : (<span className={styles.tariffsItem__priceFull}></span>)
          }
        </div>)}
        {
          item.price  && (
            <span
                className={classNames(
                    styles.tariffsItem__price,
                    {[styles.tariffsItem__price__ru]: localizationContext.locale === 'ru-RU'},
                    {[styles.tariffsItem__price__scrolled]: props.scrolledBelowTariffs},
                )}>
              {/*{props.currentPeriod === 'month' ? numberWithSpaces(item.price + props.modulesCost[item.code.toLowerCase()][periodName]) : numberWithSpaces(item.price)}*/}
              {numberWithSpaces(item.price)}
              {' '}
              { item.currency ? item.currency : '₽' }
            </span>
          )}


        <Link
            to="/registration/"
            className={styles.tariffsItem__button}
        >
          { item.button ? item.button : 'Начать' }
        </Link>
        {(item.amountPrice) ? (
        <p className={styles.tariffsItem__amount}>
          {numberWithSpaces(item.amountPrice + props.modulesCost[item.code.toLowerCase()][periodName])} {item.currency ? item.currency : '₽'} к оплате
        </p>
            ) : (<p className={styles.tariffsItem__amount}>&nbsp;</p>)}
      </div>
    )
  }

  return (
    <section className={classNames(
        styles.tariffs,
        props.className,
        {[styles.tariffsCompact]: props.scrolledBelowTariffs}
    )}>
      <div className={styles.tariffs__header}>
        <h3 className={styles.tariffs__title}>
          { getData(localizationContext.locale).title }
        </h3>

        <Switcher data={switcherData} setActive={props.setCurrentPeriod} />
      </div>

      <div className={styles.tariffs__items}>
        {currentPeriodData?.items.map(
            item => RenderItem(item, currentPeriodData.label)
        )}
      </div>

      <noindex>
        <Swiper
          className={classNames(
              styles.tariffs__items,
              styles.tariffs__itemsMobile,
          )}
          modules={[ Navigation, Pagination ]}
          breakpoints={{
            0: {
              slidesPerView: 1,
              pagination: {
                clickable: true
              }
            },
            768: {
              slidesPerView: 1
            }
          }}
          spaceBetween={15}
          pagination={{
            clickable: true,
            clickableClass: styles.swiperPagination,
            bulletClass: styles.swiperPaginationBullet,
            bulletActiveClass: styles.swiperPaginationBulletActive
          }}
          navigation={{
            nextEl: ".next",
            prevEl: ".prev"
          }}
          loop={true}
          autoHeight={false}
          onSlideChange={onSlideChange}
        >
          {currentPeriodData?.items.map(
            item => (
              <SwiperSlide key={item.name} className={styles.tariffs__itemWrapper}>
                { RenderItem(item, currentPeriodData.label) }
              </SwiperSlide>
            )
          )}

          <button
              type="button"
              className={classNames(
                  styles.navigationButton,
                  styles.navigationButtonLeft,
                  'prev',
                  {[styles.navigationButtonCompact]: props.scrolledBelowTariffs}
              )}
          >
            <ArrowLeftIcon />
          </button>

          <button
              type="button"
              className={classNames(
                  styles.navigationButton,
                  styles.navigationButtonRight,
                  'next',
                  {[styles.navigationButtonCompact]: props.scrolledBelowTariffs}
              )}
          >
            <ArrowRightIcon />
          </button>
        </Swiper>


      </noindex>
    </section>

  )
}
